// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const OnlineSchedulingTheme: ThemeFile = {
  aw: {
    classes: {
      fullWidth: 'col-span-12',
      padding: 'py-s sm:max-md:mb-8',
      height: 'md:h-[925px]',
    },
  },
  rba: {
    classes: {
      fullWidth: 'col-span-12',
      padding: 'py-s sm:max-md:mb-8',
      height: 'md:h-[925px]',
    },
  },
};
